import React from 'react';
import { Box } from '@mui/material';
import Filter from '../../components/ui/Filter';

const CaisseFilters = ({
  filters,
  onFiltersChange,
  onReset
}) => {
  // Handle individual filter changes
  const handleFilterChange = (filterName, value) => {
    let updatedFilters = {
      ...filters,
      [filterName]: value
    };

    onFiltersChange(updatedFilters);
  };

  // Define filter configuration
  const filterOptions = [
    {
      name: 'searchTerm',
      type: 'search',
      label: 'Rechercher',
      placeholder: 'Recherche...',
      isMultiSelect: false
    },
    {
      name: 'active',
      type: 'dropdown',
      label: 'Statut',
      placeholder: 'Statut: Tous',
      isMultiSelect: false,
      isSearchable: false,
      options: [
        { value: 'true', label: 'Actif' },
        { value: 'false', label: 'Inactif' }
      ]
    }
  ];

  return (
    <Box sx={{ mb: 2}}>
      {/* Filter Component */}
      <Filter
        filters={filterOptions}
        filterValues={filters}
        onFilterChange={handleFilterChange}
        onReset={onReset}
        showApplyButton={false}
      />
    </Box>
  );
};

export default CaisseFilters;
